import { TokenHistoryLabel } from "kadow-jetpack-model";

import { cleanSocialLinksByCTA } from "./cleanSocialLinksByCTA";

export function rebuildSocialLink(
  cta: TokenHistoryLabel,
  partialLink:
    | string
    | {
        lat: number;
        lng: number;
      }
) {
  let prefix = "";

  // Validate links through filter before submitting form
  // remove with caution
  partialLink = cleanSocialLinksByCTA(cta, partialLink);

  switch (cta) {
    case TokenHistoryLabel.Instagram:
    case TokenHistoryLabel.IGStory:
      prefix = "https://www.instagram.com/";
      break;

    case TokenHistoryLabel.Facebook:
      prefix = "https://www.facebook.com/";
      break;

    case TokenHistoryLabel.TikTok:
      prefix = "https://www.tiktok.com/@";
      break;

    case TokenHistoryLabel.SnapChat:
      prefix = "https://www.snapchat.com/add/";
      break;

    default:
      return "";
  }

  return `${prefix}${partialLink}`;
}
